import { render, staticRenderFns } from "./renewList.vue?vue&type=template&id=370fd8c5&scoped=true&"
import script from "./renewList.vue?vue&type=script&lang=js&"
export * from "./renewList.vue?vue&type=script&lang=js&"
import style0 from "./renewList.vue?vue&type=style&index=0&id=370fd8c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370fd8c5",
  null
  
)

export default component.exports